import DiscoutTypeImportForm from './DiscoutTypeImportForm';

export default DiscoutTypeImportForm;
